import { render, staticRenderFns } from "./TRSExtrasView.vue?vue&type=template&id=4b46afed&"
import script from "./TRSExtrasView.vue?vue&type=script&lang=js&"
export * from "./TRSExtrasView.vue?vue&type=script&lang=js&"
import style0 from "./TRSExtrasView.vue?vue&type=style&index=0&id=4b46afed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports